// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/authSlice';
import blogsReducer from './features/blogsSlice';
import commentsReducer from './features/commentsSlice';
import subscriptionReducer from './features/subscriptionSlice';
import adsReducer from './features/adsSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    blogs: blogsReducer,
    comments: commentsReducer,
    subscription: subscriptionReducer,
    ads: adsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['auth/initialize/fulfilled'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.createdAt', 'payload.updatedAt'],
        // Ignore these paths in the state
        ignoredPaths: ['blogs.items.createdAt', 'blogs.items.updatedAt'],
      },
    }),
});

export default store;